import { appendEvent, appendMessage, unmarkMessagePending } from './awsWidgetDom';
import { connectWebSocket, disconnectWebSocket } from './websocketClient';
import { sendMessage } from './messageService';

async function _sendMessage(container) {
  const input = container.querySelector('.aws-chatkit-composer-input');
  const sendBtn = container.querySelector('.aws-chatkit-send-btn');
  const text = input.value.trim();
  if (!text) return;

  const pendingMessageId = crypto.randomUUID();
  const messageGroup = appendMessage(container, 'customer', text, 'You', pendingMessageId);

  input.value = '';
  input.style.height = '';
  sendBtn.disabled = true;

  const ok = await sendMessage(container.dataset.awsConnectContactId, text);
  if (ok) {
    unmarkMessagePending(messageGroup);
  } else {
    appendEvent(container, 'Your message could not be delivered. Please try again.');
  }
}

function _bindComposer(container) {
  const input = container.querySelector('.aws-chatkit-composer-input');
  const sendBtn = container.querySelector('.aws-chatkit-send-btn');
  if (!input || !sendBtn) return;

  input.addEventListener('input', () => {
    input.style.height = 'auto';
    input.style.height = `${Math.min(input.scrollHeight, 96)}px`;
    sendBtn.disabled = !input.value.trim();
  });

  sendBtn.addEventListener('click', () => _sendMessage(container));

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      _sendMessage(container);
    }
  });
}

export function initializeAWSWidget(container, liveAgentData) {
  _bindComposer(container);
  appendEvent(container, 'Connecting to a live agent...');

  if (!liveAgentData) return;

  const { websocket_url: websocketUrl, aws_connect_contact_id: awsConnectContactId } = liveAgentData;
  container.dataset.awsConnectContactId = awsConnectContactId;
  connectWebSocket(container, websocketUrl);
}

export function destroyAWSWidget() {
  disconnectWebSocket();
}
